import { useEffect, useRef, useState } from "react";
import { getPhotoBoardDetail } from "../../../api/const";
import PhotoCell from "./PhotoCell";

export default function PhotoBoardReadonly({ photoboardId }) {
  const [board, setBoard] = useState(null);

  const imgRefs = useRef([]);
  const loadedCount = useRef(0);

  const [rowHeights, setRowHeights] = useState([]);
  const [colWidths, setColWidths] = useState([]);

  useEffect(() => {
    if (!photoboardId) return;

    (async () => {
      const data = await getPhotoBoardDetail(photoboardId);
      setBoard(data);
    })();
  }, [photoboardId]);

  if (!board) {
    return <div className="p-4 text-xs text-gray-400">사진대지 불러오는 중…</div>;
  }

  const gridX = board.grid_x || 1;
  const gridY = board.grid_y || 1;
  const total = gridX * gridY;

  /* 🔥 이미지 전부 로드된 뒤 실행 */
  const handleImageLoad = () => {
    loadedCount.current += 1;
    if (loadedCount.current !== total) return;

    const rh = Array(gridY).fill(0);
    const cw = Array(gridX).fill(0);

    imgRefs.current.forEach((img, i) => {
      if (!img) return;

      const rect = img.getBoundingClientRect();
      const row = Math.floor(i / gridX);
      const col = i % gridX;

      rh[row] = Math.max(rh[row], rect.height);
      cw[col] = Math.max(cw[col], rect.width);
    });

    setRowHeights(rh);
    setColWidths(cw);
  };

  return (
    <div className="mt-3 flex justify-center overflow-x-auto">
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            colWidths.length > 0
              ? colWidths.map((w) => `${w}px`).join(" ")
              : `repeat(${gridX}, auto)`,
          gridTemplateRows:
            rowHeights.length > 0
              ? rowHeights.map((h) => `${h}px`).join(" ")
              : `repeat(${gridY}, auto)`,
          gap: "2px",
        }}
      >
        {Array.from({ length: total }).map((_, i) => (
          <PhotoCell
            key={i}
            id={`cell-${i}`}
            photo={board.photos?.[i] || null}
            projectId={board.project}
            disabled
            onImageLoad={{
              ref: (el) => (imgRefs.current[i] = el),
              onLoad: handleImageLoad,
            }}
          />
        ))}
      </div>
    </div>
  );
}
